export interface ContactCategory {
  readonly icon: string;
  readonly title: string;
  readonly subtitle: string;
}

export const contactCategoriesConst: ContactCategory[] = [
  {
    icon: 'organizer',
    title: 'Organizatorzy gierek',
    subtitle: 'Chcesz rozkręcić granie w swoim mieście? Zróbmy to razem'
  },
  {
    icon: 'partners',
    title: 'Marki i partnerzy',
    subtitle: 'Chcesz dotrzeć do ludzi, którzy grają w piłkę?'
  },
  {
    icon: 'media',
    title: 'Media i wydarzenia',
    subtitle: 'Tworzysz content, turniej lub sportową akcję?'
  },
  {
    icon: 'municipality',
    title: 'Gminy/Zarządcy Orlików',
    subtitle: 'Chcesz, żeby na Twoim boisku grało więcej ludzi?'
  }
];
